// extracted by mini-css-extract-plugin
export default {"field":"InputLegend_field__ZSmTL","field__legend":"InputLegend_field__legend__Jfw9z"};